module.exports = __webpack_public_path__ + "img/mobile_qrcode.f4c644dd.png";